module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_header_2-66c3126bce51e8f778d5a5bf57f9ab93.webp";